import React from 'react';
import { useTranslation } from 'react-i18next';

type RoleType = 'admin' | 'manager' | 'reviewer' | 'writer' | string;

interface RoleTagProps {
  role: RoleType;
}

interface RoleStyle {
  bgColor: string;
  textColor: string;
  emoji: string;
}

const getRoleStyles = (role: RoleType): RoleStyle => {
  switch (role?.toLowerCase()) {
    case 'admin':
      return { bgColor: 'bg-[#EFFDF4]', textColor: 'text-green-700', emoji: '👑' };
    case 'manager':
      return { bgColor: 'bg-blue-100', textColor: 'text-blue-700', emoji: '💼' };
    case 'reviewer':
      return { bgColor: 'bg-[#FEFCE8]', textColor: 'text-yellow-700', emoji: '👀' };
    case 'writer':
      return { bgColor: 'bg-indigo-100', textColor: 'text-indigo-700', emoji: '✍️' };
    default:
      return { bgColor: 'bg-gray-100', textColor: 'text-gray-700', emoji: '' }; // Default style
  }
};

export const RoleTag: React.FC<RoleTagProps> = ({ role }) => {
  const { t } = useTranslation();
  const styles = getRoleStyles(role);

  // Attempt to translate the role, fallback to the role string itself
  const roleText = t(`teamMembers.roles.${role?.toLowerCase()}`, role?.charAt(0).toUpperCase() + role?.slice(1));

  return (
    <span 
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles.bgColor} ${styles.textColor}`}
    >
      {styles.emoji && <span className="mr-1.5">{styles.emoji}</span>}
      {roleText}
    </span>
  );
}; 